import styled from 'styled-components'

export const CheckBoxWrapper = styled.div`
	display: flex;
	justify-content: center;
	font-family: var(--font);
	font-weight: 300;
	margin-bottom: var(--mg-xxs);
	letter-spacing: 0.25px;
	color: #ffffff;
	padding: 5px;
`

export const Label = styled.label`
	height: 50px;
	display: flex;
	align-items: center;
	/* gap: 5px; */
`
